import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../utils/cn';

const AUTH_TABS = [
  { label: 'Sign in', path: '/login' },
  { label: 'Create account', path: '/register' },
] as const;

const HIDDEN_ON = new Set(['/verify-email', '/forgot-password', '/reset-password']);

interface AuthNavSwitcherProps {
  className?: string;
}

/** Stripe / Linear-style auth mode switcher — uses NavLink for reliable routing */
export const AuthNavSwitcher: React.FC<AuthNavSwitcherProps> = ({ className }) => {
  const { pathname } = useLocation();
  if (HIDDEN_ON.has(pathname)) return null;

  return (
    <nav
      className={cn(
        'relative flex rounded-xl border border-slate-200/80 bg-white p-1 shadow-sm',
        className
      )}
      aria-label="Authentication"
    >
      {AUTH_TABS.map((tab) => {
        const isActive = pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            replace
            className={cn(
              'relative z-10 flex-1 rounded-lg px-4 py-2.5 text-center text-sm font-medium transition-colors duration-200',
              isActive ? 'text-blue-700' : 'text-slate-600 hover:text-slate-900'
            )}
          >
            {isActive ? (
              <span
                className="absolute inset-0 rounded-lg border border-blue-100 bg-blue-50"
                aria-hidden
              />
            ) : null}
            <span className="relative">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};
